import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Alert } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

function Payment() {
  const { enrollmentId } = useParams();
  const navigate = useNavigate();
  const [enrollment, setEnrollment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchEnrollment = async () => {
      try {
        const response = await api.get(`/enrollments/${enrollmentId}`);
        setEnrollment(response.data);
      } catch (error) {
        console.error('Error fetching enrollment:', error);
        setError('Failed to load enrollment details');
      } finally {
        setLoading(false);
      }
    };

    fetchEnrollment();
  }, [enrollmentId]);

  const handlePayment = async () => {
    setProcessing(true);
    setError('');

    try {
      // Simulate payment processing
      const fakePaymentId = `FAKE_PAY_${Date.now()}`;
      console.log('💰 Simulating Razorpay Payment:', fakePaymentId);

      // Complete payment on backend
      await api.post(`/enrollments/${enrollmentId}/payment`, {
        paymentId: fakePaymentId
      });

      // Navigate to dashboard
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Payment failed');
    } finally {
      setProcessing(false);
    }
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <p>Loading payment details...</p>
      </Container>
    );
  }

  if (!enrollment) {
    return (
      <Container className="py-5">
        <Alert variant="danger">Enrollment not found</Alert>
      </Container>
    );
  }
  // Only allow payment when enrollment status is 'payment-pending'
  if (enrollment.enrollmentStatus !== 'payment-pending') {
    return (
      <Container className="py-12">
        <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-md p-8 text-center">
          <h2 className="text-2xl font-bold mb-4">Payment Not Available</h2>
          <p className="text-slate-700 mb-4">Payment is not required at this stage. Complete the screening and all sections and meet required marks to unlock payment.</p>
          <div className="flex justify-center gap-3">
            <button onClick={() => navigate('/programs')} className="px-4 py-2 bg-slate-900 text-white rounded-lg">Browse Programs</button>
            <button onClick={() => navigate(`/learning/${enrollment._id}`)} className="px-4 py-2 bg-white border border-slate-200 rounded-lg">Go to Learning Path</button>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <Card>
            <Card.Body className="p-5">
              <h2 className="text-center mb-4">Complete Payment</h2>
              
              <div className="payment-simulation mb-4">
                <h4>⚠️ FAKE PAYMENT SIMULATION</h4>
                <p className="mb-0">This is a practice project. No real payment will be processed.</p>
              </div>

              {error && <Alert variant="danger">{error}</Alert>}

              <Card className="mb-4">
                <Card.Body>
                  <h5>{enrollment.program?.title}</h5>
                  <div className="d-flex justify-content-between mt-3">
                    <span>Program Fee:</span>
                    <strong>₹{enrollment.program?.price}</strong>
                  </div>
                </Card.Body>
              </Card>

              <Button 
                variant="success" 
                size="lg" 
                className="w-100"
                onClick={handlePayment}
                disabled={processing}
              >
                {processing ? 'Processing...' : 'Pay Now (Fake)'}
              </Button>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
}

export default Payment;
